import React from "react";
import { cn } from "../../lib/utils";
import Spinner from "./Spinner";

/**
 * Véu de carregamento da página inteira.
 *
 * O `<html>` roda com `zoom: 0.8` (theme.css): dentro do zoom, 100vh e 100vw valem 80% da janela,
 * e sobrava uma faixa sem véu na borda. Dividir pelo zoom devolve o tamanho real da tela.
 */
const COBERTURA_TOTAL = {
  minWidth: "calc(100vw / var(--app-zoom, 1))",
  minHeight: "calc(100vh / var(--app-zoom, 1))",
};

export default function PageLoader({ label = "Carregando...", className = "" }) {
  return (
    <div
      className={cn(
        "fixed inset-0 z-[70] flex flex-col items-center justify-center gap-3 bg-background/70 backdrop-blur-[2px]",
        className
      )}
      style={COBERTURA_TOTAL}
    >
      <Spinner className="size-9" />
      {label ? <p className="text-sm text-muted-foreground">{label}</p> : null}
    </div>
  );
}
